import React, { useState } from 'react';
import './Recommendations.scss';
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io';

interface Recommendation {
  text: string;
  action: string;
}

const Recommendations: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const recommendations: Recommendation[] = [
    {
      text: "La semana pasada, Joaquin atendió un 20% más de clientes y redujo sus pérdidas por errores en un 7% con respecto al mes anterior.",
      action: "Revisar procedimientos de servicio y ajustar la capacitación según resultados."
    },
    {
      text: "El promedio de ventas diario de carne 5.23 kg fue de 50 con una variación de +-350 gr, si programamos el pedido cada martes y pedimos 36.2 kg, podemos minimizar el gasto de refrigeración.",
      action: "Preparar orden de 36.2 kg de carne con proveedor Frigosorno, y agendar para próximo martes."
    },
    {
      text: "Las ventas de pasta han incrementado un 15%, pero los niveles de inventario han estado bajos.",
      action: "Ajustar el inventario de pasta y aumentar el pedido semanal en un 20%."
    },
    {
      text: "El vino tinto ha estado en alta demanda los fines de semana.",
      action: "Realizar pedido adicional de vino tinto para los viernes por la tarde."
    }
  ];

  const handleActionClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="recommendations">
        <h2 className="recommendations-title">Recomendaciones de la semana</h2>
      {recommendations.map((rec, index) => (
        <div key={index} className="recommendation-item">
          <div className="recommendation-text">
            <span>{rec.text}</span>
            <button
              className="action-button"
              onClick={() => handleActionClick(index)}
            >
              <IoIosArrowDown />
            </button>
          </div>
          {activeIndex === index && (
            <div className="action-detail">
              <p className='action-detail-description'>{rec.action}</p>
              <button className="take-action-button">Tomar acción <IoIosArrowForward/></button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Recommendations;
